// export const environment = {
//   apiKey: '',
//   apiUrl: 'http://localhost:5555/',
//   projectapiUrl: 'http://localhost:5553',
//   apiImagePath: 'http://localhost:5555/',
//   authApiUrl: 'http://localhost:5555',
//   XprojectId: '18c832b3-3b88-4151-b3fc-c85651402e26'

// };

export const environment = {
  apiKey: '',
  apiUrl: 'https://microservices.genai-hub.net/',
  projectapiUrl: 'https://microservices.genai-hub.net',
  apiImagePath: 'https://microservices.genai-hub.net/',
  authApiUrl: 'https://microservices.genai-hub.net/',
  agentapiURL: 'https://microservices.genai-hub.net/',
  agentImageBaseUrl: 'https://microservices.genai-hub.net/genai-mic/agent/uploads/agents/',
  XprojectId: '18c832b3-3b88-4151-b3fc-c85651402e26',
  path: {
    agentplatform: 'genai-mic/agent/v1/system',
  }

};
